// get dashboard
export const GET_DASHBOARD = "GET_DASHBOARD";
// get top selling product
export const GET_TOP_PRODUCT = "GET_TOP_PRODUCT";
// get Top seller
export const GET_LIVE_SELLER = "GET_LIVE_SELLER";
// get Top seller
export const GET_TOP_SELLER = "GET_TOP_SELLER";
// get Top user
export const GET_TOP_USER = "GET_TOP_USER";

// Get Popular Product
export const GET_POPULAR_PRODUCT = "GET_POPULAR_PRODUCT";

// Get Recent Order

export const GET_RECENT_ORDER = "GET_RECENT_ORDER";

// get analcite data
export const GET_ANALCITE = "GET_ANALCITE";

export const GET_USER = "GET_USER";

export const GET_ORDER = "GET_ORDER";

export const GET_USER_CHART = "GET_USER_CHART";

export const GET_REVENUE_CHART = "GET_REVENUE_CHART";
